import { useState, useEffect, useRef, useCallback } from "react";

// JWT & Auth
import { isUserLoggedIn } from "@core/auth/utils";

// Redux & Action
import { useDispatch, useSelector } from 'react-redux';
import { loadGameList, setScrollStatus } from "@core/redux/actions/game/index";

// Hooks
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// Component
import { Grid } from '@mui/material';
import GameLoad from "./GameLoad";
import GameImage from "./GameImage";

export default function GameList({ selectCamp }) {
    const dispatch = useDispatch();
    const dataMenu = useSelector(state => state.reduxHome.menu);
    const homeData = useSelector(state => state.reduxHome.result);
    const itemsGameList = useSelector(state => state.reduxGame.itemsGameList);
    const [gameList, setGameList] = useState(null);
    const [rowGameCount, setRowGameCount] = useState(0);
    const [fadeIn, setFadeIn] = useState(false);
    const [scrollY, setScrollY] = useState(0);
    const scrollRef = useRef();
    const [gameLoadStatus, setGameLoadStatus] = useState(false);
    const campData = (selectCamp === undefined || selectCamp === null) ? "all" : selectCamp;
    const [checkPromotion, setCheckPromotion] = useState(null);
    const [offsetTopPostiion, setOffsetTopPostiion] = useState(null);
    // const scrollStatus = useSelector(state => state.reduxGame.scrollStatus);
    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

    const renderGameList = () => {
        if (gameList === null) return null;

        return (
            <Grid container spacing={1} columns={{ xs: 9, md: 10, lg: 16 }}>
                {
                    gameList.map((item) => {
                        return (
                            <Grid item xs={3} md={2} lg={2} key={`${item.id}`}>
                                <GameImage item={item} checkPromotion={checkPromotion}></GameImage>
                            </Grid>
                        )
                    })
                }
            </Grid>
        );
    };

    const handleNavigation = useCallback(
        e => {
            const window = e.currentTarget;
            if (scrollY < window.scrollY) {
                let boxGameHeight = scrollRef.current.offsetHeight;
                if (scrollY > (boxGameHeight / 2)) {
                    if (gameLoadStatus) {
                        if (itemsGameList !== null && itemsGameList !== false) {
                            if (checkDataByType()) {
                                let gameTypeList = itemsGameList[dataMenu.gameCampType][campData].data;
                                let countAll = gameTypeList.length;
                                setGameLoadStatus(false);
                                loadGameData(campData === "all" ? "" : campData, dataMenu.gameCampType, "", 15, countAll, true, true, []);
                            }
                        }
                    }
                }
            }

            setScrollY(window.scrollY);
        }, [scrollY, itemsGameList]
    );

    const loadGameData = (camp, type, filter, limit, offset, statusUseScroll = false, reqStatus, dataGamelist = []) => { // โหลดข้อมูลเกม
        dispatch(loadGameList({ camp, type, filter, limit, offset, statusUseScroll }, itemsGameList, reqStatus, dataGamelist, setGameLoadStatus));
    };

    const checkCountGameList = () => {
        if (gameList !== null) {
            if (rowGameCount <= 0) {
                return false;
            }
            else {
                let gameTypeList = gameList;
                let countAll = gameTypeList.length;
                if (countAll <= 0) {
                    return false;
                }
                else {
                    if (countAll < rowGameCount) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
        }
    };

    const checkDataByType = () => {
        if (itemsGameList[dataMenu.gameCampType] !== undefined) {
            if (itemsGameList[dataMenu.gameCampType][campData] !== undefined) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };


    const handleCheckScroll = useCallback(
        e => {
            const window = e.currentTarget;
            if (offsetTopPostiion !== null) {
                if (window.scrollY >= offsetTopPostiion + 50) {
                    dispatch(setScrollStatus(true));
                }
                else if (window.scrollY <= offsetTopPostiion - 50) {
                    dispatch(setScrollStatus(false));

                    return () => {
                        window.removeEventListener("scroll", handleCheckScroll);
                    };
                }
            }
        }, [scrollY, offsetTopPostiion]
    );

    useEffect(() => {
        setScrollY(window.scrollY);
    }, []);

    useEffect(() => {
        if (checkCountGameList()) {
            setScrollY(window.scrollY);
            window.addEventListener("scroll", handleNavigation);

            return () => {
                window.removeEventListener("scroll", handleNavigation);
            };
        }
    }, [handleNavigation, dataMenu, selectCamp, gameList]);

    useEffect(() => {
        if (itemsGameList !== null && itemsGameList !== false) {
            if (checkDataByType()) {
                setGameList(itemsGameList[dataMenu.gameCampType][campData].data);
                setRowGameCount(itemsGameList[dataMenu.gameCampType][campData].count);
                setGameLoadStatus(true);
            }
        }
    }, [dataMenu, selectCamp, itemsGameList]);

    useEffect(() => {
        setFadeIn(false);

        setTimeout(() => {
            setFadeIn(true);
        }, 100);
    }, [dataMenu, selectCamp]);

    useEffect(() => {
        let offsetTopData = scrollRef?.current?.offsetTop;
        if (offsetTopData !== undefined) {
            setOffsetTopPostiion(offsetTopData);
        }
    }, [scrollRef?.current?.offsetTop]);

    useEffect(() => {
        if (isUserLoggedIn()) {
            if (homeData !== null) {
                setCheckPromotion(homeData.promotion_status);
            }
        }
    }, [homeData]);

    useEffect(() => {
        if (isLargeScreen === false) {
            if (dataMenu !== null) {
                if (dataMenu?.gameCampType !== undefined) {
                    if (dataMenu?.gameCampType === 0) {
                        window.addEventListener("scroll", handleCheckScroll);
                    }
                }
            }
        }
    }, [handleCheckScroll, dataMenu]);

    return (
        <>
            <div ref={scrollRef}>
                {
                    gameList !== null && (
                        <>
                            <div className={fadeIn ? "fadeIn" : "fadeInHide"}>
                                {
                                    renderGameList()
                                }
                            </div>

                            <br />
                            {
                                gameLoadStatus === false && (
                                    <GameLoad></GameLoad>
                                )
                            }
                        </>
                    )
                }
            </div>
        </>
    );
}